<template>
  <!-- 售后详情-添加标签 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="40%"
    class="dialog"
    center
  >
    <div class="contents">
      <el-form
        :model="formData"
        ref="refForm"
        :rules="formRules"
        label-position="right"
        label-width="100px"
      >
        <div class="mb-15" style="padding-left: 65px;">
          标签：
          <el-tag
            v-for="(bItem, bIndex) in showList"
            :key="bIndex"
            :closable="bItem.type==2"
            style="margin-right: 10px"
            @close="close(bItem)"
          >
            {{ bItem.name }}
          </el-tag>
          <!-- <span
            class="mr8"
            style="background: #f5f6f8; padding: 5px"
            v-for="(bItem, bIndex) in showList"
            :key="bIndex"
            >{{ bItem.name }}</span
          > -->
        </div>
        <el-form-item label="新增标签:" prop="label_id">
          <el-select
            placeholder="选择标签"
            v-model="formData.label_id"
            clearable
            filterable
          >
            <el-option
              v-for="item of chooseList"
              :disabled="item.disabled"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取消</el-button>
      <el-button type="primary" @click="onHandleSubmit" :loading="loading"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "addLabelDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      title: "",
      loading: false,
      info: {},
      showList: [],
      chooseList: [],
      formData: {
        label_id: "", // 供应商ID
      }, // 表单数据
      formDataClone: {}, // 复制一份，用于初始化
      formRules: {
        label_id: [
          {
            required: true,
            message: "请选择新增标签",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    close(e){
console.log(e,'删除标签')
this.$api.member.memberdellabel({
  member_id:this.info.id,
  label_id:e.id
}).then(res=>{
  this.showList = this.showList.filter(item => item.id !== e.id);
  this.chooseList.forEach(el=>{
    if(el.id==e.id){
      el.disabled=false
    }
  })
this.$message.success("删除标签！");
})
    },
    /**
     * 初始化
     */
    onInitData(data, list) {
      console.log(data, list, "data-===");
      this.info = data;
      this.showList = list ? list : data?.labels || []; // 已绑定标签
      this.title = `客户：${data?.fullname}${data?.mobile}`;
      this.memberAjaxLabelType2(data.id);
      this.dialogVisible = true;
      this.formData.label_id = "";
      this.$refs.refForm?.resetFields();
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
       this.$emit("on-refresh-list", this.info.id);
    },
    // 客户标签下拉列表接口
    async memberAjaxLabelType2(id) {
      try {
        const res = await this.$api.member.memberLabelType2({ member_id: id });
        console.log(res);
        this.chooseList = res.data || [];
      } catch (error) {
        console.log(error, "memberLabelType2");
      }
    },
    // 提交
    onHandleSubmit() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const res = await this.$api.member.memberLabelBind({
              member_id: this.info.id,
              label_id: this.formData.label_id,
            });
            this.dialogVisible = false;
            this.$emit("on-refresh-list", this.info.id);
          } catch (error) {
            console.log(error, "memberLabelBind");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .boxWrap {
    font-weight: 500;
    font-size: 14px;
  }
  /deep/ .el-dialog__header {
    height: 20px !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px;
  }
}
</style>
